import React from "react";
import Select from "react-select";

export const INVOICE_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "working", label: "Working" },
  { value: "ready_to_review", label: "Ready to Review" },
  { value: "new", label: "New" },
  { value: "published", label: "Published" },
  { value: "unpublished", label: "Unpublished" },
  { value: "republished", label: "Republished" },
];

const Filter = ({ statusFilter = [], onStatusFilterChange }) => {
  const handleChange = (selected) => {
    const next = selected || [];

    if (!next.length) {
      onStatusFilterChange?.([{ value: "all", label: "All" }]);
      return;
    }

    const lastSelected = next[next.length - 1];
    if (lastSelected?.value === "all") {
      onStatusFilterChange?.([{ value: "all", label: "All" }]);
      return;
    }

    onStatusFilterChange?.(
      next.filter((option) => option?.value && option.value !== "all"),
    );
  };

  return (
    <div style={{ minWidth: 260, maxWidth: 360 }}>
      <Select
        isMulti
        options={INVOICE_STATUS_FILTER_OPTIONS}
        value={statusFilter}
        onChange={handleChange}
        placeholder="Filter by status..."
        className="multi-select w-100"
        classNamePrefix="react-select"
        isSearchable
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
    </div>
  );
};

export default Filter;
